import { Model } from 'dva'
import { WorkerSIPLine } from './types'
import { TelephonyService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const WorkerSIPLines: Model = {
  namespace: 'workerSIPLines',
  state: {
    list: [],
  },
  effects: {
    *list(
      { id, useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let workerSIPLines = yield select((state: any) =>
          state.workerSIPLines.list.filter((item: WorkerSIPLine) => item.worker.id === id)
        )
        if (!(workerSIPLines.length > 0 && useCache)) {
          workerSIPLines = yield call(TelephonyService.telephonyWorkersSipLinesList, {
            workerPk: id,
          })
          yield put({ type: 'modifyList', payload: workerSIPLines })
        }
        onSuccess(workerSIPLines)
      } catch (err: any) {
        FailureHandler('Error fetching ASR Models', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { workerId, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let sipLine = yield select((state: any) =>
          state.workerSIPLines.list.find((sipLine: WorkerSIPLine) => sipLine.id === id)
        )
        if (!sipLine) {
          sipLine = yield call(TelephonyService.telephonyWorkersSipLinesRetrieve, {
            id: id,
            workerPk: workerId,
          })
        }
        yield put({ type: 'modifyList', payload: sipLine })
        onSuccess(sipLine)
      } catch (err) {
        FailureHandler('Could not find the ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { workerId, data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyWorkersSipLinesCreate, {
          requestBody: data,
          workerPk: workerId,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, workerId, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyWorkersSipLinesPartialUpdate, {
          id: id,
          workerPk: workerId,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { idParentAlias, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TelephonyService.telephonyWorkersSipLinesDestroy, {
          id: id,
          workerPk: idParentAlias,
        })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a sipLine', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: WorkerSIPLine) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter(
            (l: WorkerSIPLine) => !action.payload.map((p: WorkerSIPLine) => p.id).includes(l.id)
          )
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: WorkerSIPLine) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetWorkerSIPLines(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default WorkerSIPLines
